module.exports = __webpack_public_path__ + "components/outside-promo-page/static/mountainbikers-8bd877738e5c459b014ac76f13dda7c5.webp";